export enum UigExportTypes {
  csv
}

export enum SearchType {
  PRODUCT,
  CONTENT
}